<template>
  <div class="TestKitList">
    <div class="form">
      <el-form
        ref="formRef"
        :inline="true"
        label-width="100px"
        :model="form"
        @submit.native.prevent
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="患者姓名" prop="username">
              <el-input
                v-model="form.username"
                clearable
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="微信昵称" prop="nickname">
              <el-input
                v-model="form.nickname"
                clearable
                placeholder="请输入微信昵称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="form.phone"
                clearable
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证号" prop="idCardNo">
              <el-input
                v-model="form.idCardNo"
                clearable
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检查类型" prop="checkItem">
              <el-select v-model="form.checkItem" clearable placeholder="请选择">
                <el-option
                  v-for="item in checkItemList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检查时间" prop="checkDateList">
              <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="form.checkDateList"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="管理医生" prop="identify">
              <el-select v-model="form.identify" clearable placeholder="请选择">
                <el-option
                  v-for="item in doctor_list"
                  :key="item.id"
                  :label="item.docName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="8">
              <el-form-item label="患者状态" prop="patientStatus">
                <el-select v-model="form.patientStatus" clearable placeholder="请选择">
                  <el-option
                      v-for="item in patient_status"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>-->
          <el-col :span="24">
            <el-form-item class="TestKitList-form-button">
              <el-button
                @click="onSubmit(form)"
                type="primary"
                native-type="submit"
                >查询</el-button
              >
              <el-button @click="Reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list">
      <div class="TestKitList-list-handle">
        <div style="overflow-x: auto; width:100%;">
          <div class="grouping-box">
            <div class="grouping" style="">
              <div
                class="item-grouping"
                v-for="(item, index) in groupList"
                :key="index"
                @click="groupingClick(item)"
              >
                <span>{{ item.leaderName ? `${item.leaderName}的${item.name}` : item.name }}</span>
                <div
                  :class="{ SelectedGrouping: groupData.id === item.groupId }"
                  class="Selected"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <el-button
              @click="ChangeGroupingAll"
              class="btn"
              :type="groupDisabled ? 'info' : 'primary'"
              :disabled="groupDisabled"
              size="small">全部更换</el-button>
          <el-button
            @click="ChangeGrouping"
            class="btn"
            :type="groupDisabled ? 'info' : 'primary'"
            size="small"
            :disabled="groupDisabled"
            >更换分组</el-button
          >
          <el-button class="btn"
                     @click="add"
                     size="small"
                     :type="addDisabled ? 'info' : 'primary'"
                     :disabled="addDisabled"
            >添加患者</el-button
          >
        <!--        <el-button type="primary" @click="add" size="small" >导出全部数据</el-button>-->
        <!--        <el-button type="primary" @click="add" size="small" >下载问卷内容模板</el-button>-->
        <!--        <el-button type="primary" @click="add" size="small" >导入问卷内容</el-button>-->
      </div>
      <el-table
          ref="tableRef"
          :data="table"
          v-loading="tableLoad"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          style="width: 100%"
          row-key="patientId"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" reserve-selection width="55"> </el-table-column>
        <el-table-column prop="serialNumber" align="center" label="序号" />
        <el-table-column prop="patientName" align="center" label="患者姓名">
          <template slot-scope="scope">
            <span :class="isEdit ? 'TestKitList-list-blue' : null" @click="detail(scope.row)">{{
              scope.row.patientName? scope.row.patientName:'--'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" align="center" label="微信昵称" />
        <el-table-column prop="phoneNo" align="center" label="手机号">
        </el-table-column>
        <el-table-column prop="idCardNo" align="center" label="身份证号">
        </el-table-column>
        <el-table-column prop="medicalCardNo" align="center" label="医保卡号">
        </el-table-column>
        <el-table-column prop="age" align="center" label="年龄">
        </el-table-column>
        <el-table-column prop="gender" align="center" label="性别">
          <template #default="scope">
            <span>{{ gender_name(scope.row.gender) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="birth" align="center" label="出生日期">
        </el-table-column>
        <el-table-column prop="checkItem" align="center" label="检查类型" >
          <template #default="scope">
            <span>{{ checkItemName(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="checkDate" align="center" label="检查时间" />
        <el-table-column prop="docName" align="center" label="管理医生">
        </el-table-column>
        <el-table-column prop="groupName" align="center" label="患者分组" />
        <el-table-column prop="" align="center" label="报告">
          <template #default="scope">
            <el-button @click="see(scope.row, 'report')" type="text"
              >查看</el-button
            >
            <!--            <template v-if="scope.row.report" >-->
            <!--              <el-button @click="see(scope.row,'report')" type="text" >查看</el-button>-->
            <!--            </template>-->
            <!--            <template v-else>-->
            <!--              <span>&#45;&#45;</span>-->
            <!--            </template>-->
          </template>
        </el-table-column>
        <!--        <el-table-column
              prop=""
              align="center"
              label="肠道准备详情">
            <template #default="scope">
              <div class="newBox">
                <el-button @click="see(scope.row,'details')" type="text" >查看</el-button>
                <template v-if="scope.row.unreplay" >
                  <p class="new_text">new!</p>
                </template>
              </div>
  &lt;!&ndash;            <template v-if="scope.row.gutPrepare" >&ndash;&gt;
  &lt;!&ndash;              <el-button @click="see(scope.row,'details')" type="text" >查看</el-button>&ndash;&gt;
  &lt;!&ndash;            </template>&ndash;&gt;
  &lt;!&ndash;            <template v-else>&ndash;&gt;
  &lt;!&ndash;              <span>&#45;&#45;</span>&ndash;&gt;
  &lt;!&ndash;            </template>&ndash;&gt;
            </template>
          </el-table-column>-->
        <el-table-column prop="" align="center" label="复诊建议">
          <template #default="scope">
            <el-button @click="see(scope.row, 'proposal')" type="text"
              >查看</el-button
            >
            <!--            <template v-if="scope.row.visitCommend" >-->
            <!--              <el-button @click="see(scope.row,'proposal')" type="text" >查看</el-button>-->
            <!--            </template>-->
            <!--            <template v-else>-->
            <!--              <span>&#45;&#45;</span>-->
            <!--            </template>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <reportDialog
      v-model="report_model"
      :list="report_list"
      :patientOpenId="patientOpenId_"
      :patientId="patientId"
    />
    <detailsDialog v-model="details_model" :list="details_list" />
    <proposalDialog
      v-model="proposal_model"
      :list="proposal_list"
      :patientOpenId="patientOpenId_"
      :patientId="patientId"
    />
    <GroupingDialog v-model="GroupingData.show" v-bind="GroupingData" @updateList="replaceSuccess" ></GroupingDialog>
  </div>
  </div>
</template>

<script>
import reportDialog from "@/components/TestKit/dialog/report-dialog";
import detailsDialog from "@/components/TestKit/dialog/details-dialog";
import proposalDialog from "@/components/TestKit/dialog/proposal-dialog";
import GroupingDialog from "@/components/TestKit/dialog/groupingDialog";
export default {
  name: "PatientManagement",
  components: {
    reportDialog,
    detailsDialog,
    proposalDialog,
    GroupingDialog
  },
  data() {
    return {
      roleidDisabled:false,
      form: {
        pageNum: 1,
        pageSize: 10,
        username: "",
        phone: "",
        idCardNo: "",
        identify: "",
        checkItem: "",
        checkDateList: [],
        patientStatus: "",
      },
      checkItemList: [], // 检查类型
      total: 0,
      doctor_list: [],
      table: [],
      tableLoad: false,
      range: [
        {
          value: "1",
          text: "男",
        },
        {
          value: "0",
          text: "女",
        },
      ],
      report_list: [],
      patientOpenId_: "",
      patientId: "",
      report_model: false,
      details_list: [],
      details_model: false,
      proposal_list: [],
      proposal_model: false,
      patient_status: [
        {
          key: "0",
          value: "待回复",
        },
        {
          key: "1",
          value: "已回复",
        },
        {
          key: "2",
          value: "未提交",
        },
      ],
      selectList: [],
      groupList: [],
      groupData: {
        id: "",
        leaderId: "",
      },
      GroupingData: {
        show: false,
        docId: "",
        oldGroupId: "",
        ids: "",
      },
    };
  },
  computed: {
    isEdit() {
      return this.$store.state.doctor_id || this.$store.state.roleName == '超级管理员' || this.$store.state.roleName == '管理员';
    },
    gender_name() {
      return function(row) {
        let str;
        str = this.range
          .filter((item) => item.value === row)
          .map((item) => item.text)[0];
        return str;
      };
    },
    checkItemName() {
      return function(e) {
        let str = "";
        const obj = (this.checkItemList || []).find((item) => item.dictKey === e.checkItem);
        if (obj) str = obj.dictValue;
        return str;
      }
    },
    groupDisabled() {
      let flag = true;
      if (!this.groupData.id) return flag;
      if ((this.groupData.leaderId === this.$store.state.doctor_id || this.$store.state.roleName == '超级管理员' || this.$store.state.roleName == '管理员') && this.table.length > 0 ) {
        flag = false;
      }
      return flag;
    },
    addDisabled() {
      let flag = true;
      if (!this.groupData.id) return flag;
      if (this.groupData.leaderId === this.$store.state.doctor_id || this.$store.state.roleName == '超级管理员' || this.$store.state.roleName == '管理员') {
        flag = false;
      }
      return flag;
    }
  },
  created() {
    console.log(this.$store.state.role_id,`role_id`);
    if(this.$store.state.role_id==1) this.roleidDisabled=true
    // this.doctorlistFn();
    this.getCheckItemList();
    this.getDoctorList();
    this.getGroupList();
  },
  mounted() {},
  methods: {
    replaceSuccess() {
      this.$refs.tableRef.clearSelection();
      this.selectList = [];
      this.form.pageNum = 1;
      this.get_list();
    },
    async getCheckItemList() {
      try {
        const res = await this.$get("base/dict/checkItem")
        if (!res) return false;
        const { data } = res;
        this.checkItemList = data;
      }catch (e) {
        console.error(e);
      }
    },
    async getGroupList() {
      try {
        const res = await this.$get('group/list',{
          docId: this.$store.state.doctor_id
        });
        if (!res) return false;
        const { data } = res;
        this.groupList = [{
          groupId: "",
          name: "全部患者",
          leaderId: "",
        },...data];
        this.get_list();
      }catch(e){
        console.error(e);
      }
    },
    handleSelectionChange(e) {
      this.selectList = (e || []).map((item) => item.patientId);
    },
    // 点击更换分组
    ChangeGrouping() {
      console.log('999...',this.selectList.length);
      
      if (this.selectList.length === 0) return this.$message.warning("请选择要更换分组的患者");
      this.GroupingData.ids = this.selectList.join(",");
      this.GroupingData.show = true;
      console.log(this.GroupingData)
    },
    // 更换全部分组
    ChangeGroupingAll() {
      this.GroupingData.ids = "all";
      this.GroupingData.show = true;
    },
    async groupingClick(item) {
      this.groupData.id = item.groupId;
      this.groupData.leaderId = item.leaderId;

      this.GroupingData.docId = item.leaderId;
      this.GroupingData.oldGroupId = item.groupId;

      this.$refs.tableRef.clearSelection()
      this.form.pageNum = 1;
      await this.get_list();
    },
    add() {
      /*this.$router.push({
        path: "/subjectAllDetails",
        query: {
          leaderId: this.groupData.leaderId,
          groupId: this.groupData.id,
        },
      });*/
      this.$router.push({
        path: "/bowelPreparationDetails",
        query: {
          leaderId: this.groupData.leaderId,
          groupId: this.groupData.id,
        },
      });
    },
    detail(row) {
      if (!this.isEdit) return false;
      this.$router.push({
        path: "/bowelPreparationDetails",
        query: {
          id: row.patientId,
          docId: row.docId,
          leaderId: this.groupData.leaderId,
          // groupId: this.groupData.id,
          groupId: row.groupId,
        },
      });

      /*this.$post("gp/getPageNumber",{
          userId: row.patientId
        })
          .then(res => {
            if(res) {
              let data_ = res.data;

              this.$router.push({
                path: "/subjectAllDetails",
                query: {
                  userId: row.patientId,
                  docId: row.docId,
                  pageNumber: data_,
                }
              })

            }
          })*/
    },
    see(row, str) {
      console.log(row);
      this.patientOpenId_ = row.patientOpenId;
      this.patientId = row.patientId;
      switch (str) {
        case "report":
          this.$get(`colondoc/report/${row.patientId}`).then((res) => {
            if (res) {
              let data_ = res.data;
              this.report_list = data_;
              this.report_model = true;
            }
          });

          break;
        case "details":
          this.$get("colondoc/bowlResultDetal", {
            docOpenId: row.docOpenId,
            patientId: row.patientId,
          }).then((res) => {
            if (res) {
              let data_ = res.data.map((item) => {
                item.jsonObject.picList = (item.jsonObject.picList || []).map(
                  (item_) => {
                    item_["result_"] = "";
                    item_["remark_"] = "";
                    item_["is_reply"] = true;
                    return item_;
                  }
                );
                return item;
              });
              this.details_list = data_;
              this.details_model = true;
            }
          });
          break;
        case "proposal":
          this.$get(`colondoc/visits/${row.patientId}`).then((res) => {
            if (res) {
              let data_ = res.data;
              this.proposal_list = data_.map((item) => {
                item["is_edit"] = true;
                return item;
              });
              this.proposal_model = true;
            }
          });
          break;
      }
    },
    onSubmit(y) {
      y.current = 1;
      y.pageNum = 1;
      this.get_list(y);
    },
    Reset() {
      this.$refs["formRef"].resetFields();
      this.$nextTick(() => {
        this.get_list();
      });
    },
    get_list() {
      let obj = {
        ...this.form,
      };
      if (!obj.checkDateList) {
        obj.checkDateList = [];
      }
      this.$post("gp/getPatientList", {
        ...obj,
        groupId: this.groupData.id,
      }).then((res) => {
        if (res) {
          let data_ = res.data;
          this.total = data_.total;
          this.table = data_.records;
        }
      });
    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.get_list();
    },
    handleCurrentChange(e) {
      this.form.pageNum = e;
      this.get_list();
    },
    async getDoctorList() {
      try {
        const res = await this.$get("gp/getNewDoctorList");
        if (!res) return false;
        const { data } = res;
        this.doctor_list = data;
      }catch (e) {
        console.error(e);
      }
    },
    doctorlistFn() {
      this.$get(`gp/getDoctorList/${"0"}`).then((res) => {
        if (res) {
          console.log(res);
          let data_ = res.data;
          this.doctor_list = data_;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/TestKit/TestKitList";
.TestKitList-list-handle {
  display: flex;
  flex-direction: column;
  .btn {
      width: 100px;
      height: 40px;
      font-size: 15px;
    }

  .grouping-box {
    width: 100%;
    display: flex;
    padding: 0 15px;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 10px;
    // gap: 20px;
    .grouping {
      display: flex;
      gap: 30px;
    }
    .item-grouping {
      cursor: pointer;
      font-size: 22px;
      // width: 100px;
      min-width: 88px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 0 0 auto;
      .Selected {
        width: 81px;
        height: 7px;
        background-color: #fff;
        margin-top: 10px;
        border-radius: 7px;
      }
      .SelectedGrouping {
        background-color: #2561ef;
      }
    }
  }
}
:deep(.el-date-editor){
  width: 280px!important;
}
.el-input,.el-select{
  width: 280px!important;
}
</style>
